import React, { useState, useEffect } from 'react';


export default function CheckboxGroup({ items, setSelectedCustomer, requestType }) {
    const [selectedValues, setSelectedValues] = useState([]);
    const [allSelected, setAllSelected] = useState(false);
    // Handle individual checkbox change
    const handleSingleCheck = (value) => {
        const newSelected = selectedValues.includes(value)
            ? selectedValues.filter(v => v !== value)
            : [...selectedValues, value];

        setSelectedValues(newSelected);
        setSelectedCustomer(newSelected);
        // setAllSelected(newSelected.length === items.length);
    };
    const handleSingleCheck2 = (value) => {
        const checkboxes = document.querySelectorAll('input[name="itemspax"]:checked');
        const newSelected = [];
        checkboxes.forEach((checkbox) => {
            newSelected.push(checkbox.value);
        });
        setSelectedValues(newSelected);
        setSelectedCustomer(newSelected);
        //  setAllSelected(newSelected.length === items.length);

    };
    useEffect(() => {
        if (requestType === '8') {
            if (!allSelected) {
                handleCheckAll(true);
            }
        } else {
            if (allSelected) {
                handleCheckAll(false);
            }
        }
    }, [requestType]);
    // Handle "Check All" change
    // const handleCheckAll = () => {
    //     if (allSelected) {
    //         setSelectedValues([]);
    //         setSelectedCustomer([]);
    //     } else {
    //         setSelectedValues(items.map(item => item.segkey));
    //         setSelectedCustomer(items.map(item => item.segkey));
    //     }
    //     setAllSelected(!allSelected);
    // };

    const handleCheckAll = (checked) => {
        if (requestType === '8' && checked === false) {
            return;
        }
        if (checked) {
            setSelectedValues(items.map(item => item.segkey));
            setSelectedCustomer(items.map(item => item.segkey));
        } else {
            setSelectedValues([]);
            setSelectedCustomer([]);
        }

        setAllSelected(checked);
    };
    return (
        <>

            <h2 className="text-3 p-2">Passenger Details :
                <label>
                    <input type='checkbox'
                        checked={allSelected}
                        onChange={(e) => {
                            if (requestType === '8') return;
                            handleCheckAll(e.target.checked);
                        }}
                        indeterminate={selectedValues.length > 0 && selectedValues.length < items.length}
                    />
                    Select All Passenger
                </label>
            </h2>

            <div className="row">
                <div className="col-md-12">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-2 gap-4">
                        {items.map((citem) => (
                            <div key={'dddds' + citem.id} className=" pl-3">
                                <label className="flex items-center gap-2">
                                    <input type="checkbox" disabled={(citem.is_amendments === 1 || citem.is_amendments === 9)} name='itemspax' value={citem.segkey} className="accent-blue-500"
                                        // onChange={() => handleSingleCheck2(citem.segkey)}
                                        onChange={(e) => {
                                            if (requestType === '8') return;
                                            handleSingleCheck2(citem.segkey)
                                        }}
                                        checked={selectedValues.includes(citem.segkey)}
                                        defaultChecked={false}
                                    />
                                    <span className="font-semibold">{citem.title + '. ' + citem.fname + ' ' + citem.lname + ' (' + citem.PaxType + ')'} <span className="font-semibold text-red-600">{((citem.is_amendments === 1 || citem.is_amendments === 9)) ? 'CAN/MODE' : ''}</span></span>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

        </>

    );
};